import { render, staticRenderFns } from "./integralGoodsItem.vue?vue&type=template&id=789c5d69&scoped=true&"
import script from "./integralGoodsItem.vue?vue&type=script&lang=js&"
export * from "./integralGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./integralGoodsItem.vue?vue&type=style&index=0&id=789c5d69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789c5d69",
  null
  
)

export default component.exports